import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
export var content = {
  name: "1e08qv8",
  styles: "margin:22px 0 37px;text-align:center;padding:10px;"
};
export var contents = {
  name: "dbpe6y",
  styles: "margin:22px 0 37px;text-align:center;padding:10px 10px 57px;"
};
export var text = /*#__PURE__*/css("font-family:", variables.font.headingFontFamily, ";font-size:", variables.font.h4FontSize, ";font-weight:", variables.font.headingFontWeight, ";color:", variables.colour.neutral700, ";margin-top:24px;");
export var image = {
  name: "c74ei4",
  styles: "width:320px;height:118px;"
};
export var actions = {
  name: "44l2jp",
  styles: "li{margin-top:15px;&::before{content:'\\2022';margin-right:10px;}}"
};
export var powWrapper = /*#__PURE__*/css("margin-bottom:32px;background-color:", variables.colour.white, ";padding:0;padding-top:32px;", media('>=tablet'), "{padding:32px 0;}");
export var button = /*#__PURE__*/css("font-family:", variables.font.bodyFontFamily, ";font-size:", variables.font.baseFontSize, ";text-decoration:underline;color:", variables.colour.link, ";background:none;border:0;outline:0;cursor:pointer;padding:0;");